<!--
ActiveDirectory login. (Uses the msal plugin)

@author cm359n
-->
<template>
    <div id="contain" class="container">
        <div class='errorMsg' v-if="errorOccurred">
          {{ errorMsg }}
        </div>
        <div>
            <div v-if="username">
              Hello {{ username }}
              <router-link to="/adlanding">homepage</router-link>
            </div>
            <div v-else class="infoField">Please login.</div>
            <button @click=testRedirect()>Click here to login</button>
        </div>
    </div>
  </template>
  
  <script setup>
  // import axios from 'axios'
  import { onMounted, ref } from 'vue'
  import { PublicClientApplication } from "@azure/msal-browser"
  import { UofGMSALConfig } from './authConfig'
  import { useRoute } from 'vue-router'

  // const { authenticated } = useLocationsCommon()
  const route = useRoute()
  const msalInstance = ref(null)
  const errorOccurred = ref(false)
  const errorMsg = ref('')
  const username = ref('')
  onMounted(async () => {
    console.log('hello')
    console.log(route)
    /* const msalConfig = {
        auth: {
            clientId: 'c9efa4d2-a3f0-4098-ba85-0643d408bacd'
        }
    } */
    const msalConfig = UofGMSALConfig

    // msalInstance.value = new PublicClientApplication(msalConfig)
    // await msalInstance.value.initialize()
    msalInstance.value = await PublicClientApplication.createPublicClientApplication(msalConfig)
    console.log('i hope it worked!')

    msalInstance.value.handleRedirectPromise().then((tokenResponse) => {
      console.log('token response is')
      console.log(tokenResponse)

    // Check if the tokenResponse is null
    // If the tokenResponse !== null, then you are coming back from a successful authentication redirect.
    // If the tokenResponse === null, you are not coming back from an auth redirect.
    // TEST TEST TEST
      if (tokenResponse !== null) {
          if (tokenResponse.account.username) {
            username.value = tokenResponse.account.username
          }
          console.log('what is the account??')
          console.log(msalInstance.value.getAllAccounts()[0])
          msalInstance.value.acquireTokenSilent({
              account: msalInstance.value.getAllAccounts()[0],
              scopes: ["User.Read"]
          }).then(atResponse => {
            console.log('acquireTokenSilent returned with ')
            console.log(atResponse)
          })
      }
    // END TEST
    }).catch((error) => {
        // handle error, either in the library or coming back from the server
        console.error(error)
    })

  }) // end onMounted

  /* function getParamsFromHash(str) {
    if (typeof str !== 'undefined' && str != null && str.length > 0) {
      const params = str.substring(1).split('&')
      console.log(params)
    } else {
      console.error('route hash not present - login did not occur (yet?)')
    }
  } */
  function testRedirect() {
    try {
        msalInstance.value.loginRedirect({})
    } catch (err) {
        console.error('ERROR with MSAD login...')
        console.log(err)
    }
  }
  </script>
  
  <style>
  .infoField {
    background-color:#ffffff;
    color: var(--uog-dark-blue);
    font-weight:700;
    border-left:0px;
    border-bottom:1px solid #e4e4e4;
    border-right:0px;
    line-height:48px;
    margin-left:24px;
    margin-right:24px;
    height:48px;
    font-family:PTSans;
  }
  </style>
  